import React, { Component } from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import { uepClient } from "uepClient";
import { ReactComponent as CrossIcon } from "images/cross-icon.svg";
import { connect } from "react-redux";
import { loadAttachments } from "actions/attachmentActions";
import "./FileSelector.scss";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: 40,
    minHeight: 40,
    font: "normal normal bold 14px/19px Roboto",
    background: "#F6F9FC",
    boxShadow: "3px 3px 9px #00000029",
    border: "none",
    color: "#838EAB",
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    height: 34,
    minHeight: 34,
    letterSpacing: "0px",
    color: "#838EAB",
    font: isFocused
      ? "normal normal bold 14px/19px Roboto"
      : "normal normal normal 14px/19px Roboto",
    backgroundColor: isSelected || isFocused ? "#3A8AFA29" : "white",
    border: "none",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#838EAB",
    font: "normal normal normal 16px/21px Roboto",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    width: 28,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#838EAB",
    font: "normal normal normal 16px/21px Roboto",
  }),
};

const DropdownIndicator = (props) => {
  const { onClick, ...rest } = props;
  return (
    <components.DropdownIndicator {...rest}>
      <CrossIcon onClick={onClick} className="cross-icon" />
    </components.DropdownIndicator>
  );
};

class FileSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBrochure: "",
    };
  }

  componentDidMount() {
    this.fetchFiles();
  }

  fetchFiles = () => {
    uepClient()
      .get(`file-info`)
      .then((response) => {
        this.props.loadAttachments(response.data);
      })
      .catch((error) => {
        console.error("Some Error Occured:", error.message);
      });
  };

  handleFileSelection = (selectedFile) => {
    this.props.attachSelectedFile(selectedFile);
  };

  handleClick = () => {
    this.props.onFileSelectorClose();
  };

  renderDropdownIndicator = (props) => {
    return <DropdownIndicator {...props} onClick={this.handleClick} />;
  };

  render() {
    let options = this.props.attachments.map((brochure) => {
      return {
        value: brochure,
        label: brochure.label + "  (" + brochure.format + ")",
      };
    });

    return (
      <div data-testid="file-selector-container">
        {this.props.showSelector && (
          <Select
            onBlur={this.handleClick}
            autoFocus={true}
            openMenuOnFocus={true}
            closeMenuOnSelect={true}
            options={options}
            styles={customStyles}
            maxMenuHeight={150}
            placeholder="Search the file name"
            components={{
              DropdownIndicator: this.renderDropdownIndicator,
              IndicatorSeparator: () => null,
            }}
            onChange={(selectedOption, triggeredAction) => {
              if (triggeredAction.action === "clear") {
                this.setState({
                  selectedBrochure: "",
                });
              } else {
                this.setState({
                  selectedBrochure: selectedOption.value,
                });
                this.handleFileSelection(selectedOption.value);
              }
            }}
          />
        )}
      </div>
    );
  }
}

FileSelector.propTypes = {
  attachments: PropTypes.array,
};

const mapStateToProps = (state) => ({
  attachments: state.attachments,
});

export default connect(mapStateToProps, { loadAttachments })(FileSelector);
